import type { ElementType } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
    shouldDisplay: boolean;
    redirectTo: string;
    element: ElementType;
}

const ProtectedRoute = ({ shouldDisplay, redirectTo, element: Element }: ProtectedRouteProps) => {
    return shouldDisplay ? (
        <Element />
    ) : (
        <Navigate data-testid="navigate" to={redirectTo} replace />
    );
};

export default ProtectedRoute;
